import React from 'react';
import Input from './Input';
import './Footer.scss'

const Footer = () => {
    return (
        <footer>
            <h6>Get notified when we launch</h6>
            <Input />
        </footer>
    );
}
 
export default Footer;